import MemberActivityContent from "./MemberActivityContent";

export default MemberActivityContent;
